<template>
    <div id="reworkRecord">
        <el-card class="table_searchbar">
            <el-row style="margin-bottom:20px">
                <el-col :span="5">
                    <div class="y_table" @keydown.enter="btnSearch()">
                        <span class="title y_table_span">工单号：</span>
                        <el-select clearable filterable v-model='searchForm.splitId' @visible-change="($event)=>{if(!$event){loadProductionBatchCode('')}}" remote :remote-method="query=>loadProductionBatchCode(query)" class="y_table_cellLogy" style="min-width:100px ;max-width: 200px" size='small' placeholder='工单号' >
                            <el-option v-for="item in productionBatchCodeList" :key="item.splitId" :value="item.splitId" :label="item.productionBatchCode"></el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div @keydown.enter="btnSearch()" class="y_table">
                        <span class="title y_table_span">物料编码：</span>
                        <el-select clearable filterable v-model='searchForm.materialCode' @visible-change="($event)=>{if(!$event){loadMaterialCodeList('')}}" remote :remote-method="query=>loadMaterialCodeList(query)" class="y_table_cellLogy" style="min-width:100px ;max-width: 200px" size='small' placeholder='物料编码' >
                            <el-option v-for="item in materialCodeList" :key="item.materialCode" :value="item.materialCode" :label="item.materialCode"></el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="y_table" @keydown.enter="btnSearch()">
                        <span class="title y_table_span">物料名称：</span>
                        <el-select clearable filterable v-model='searchForm.materialName' @visible-change="($event)=>{if(!$event){loadMaterialNameList('')}}" remote :remote-method="query=>loadMaterialNameList(query)" class="y_table_cellLogy" style="min-width:100px ;max-width: 200px" size='small' placeholder='物料名称' >
                            <el-option v-for="item in materialNameList" :key="item.materialCode" :value="item.materialName" :label="item.materialName"></el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="y_table" @keydown.enter="btnSearch()">
                        <span class="title y_table_span">工序：</span>
                        <el-select clearable filterable v-model='searchForm.procedureName' @visible-change="($event)=>{if(!$event){loadProcedureList('')}}" remote :remote-method="query=>loadProcedureList(query)" class="y_table_cellLogy" style="min-width:100px ;max-width: 200px" size='small' placeholder='工序' >
                            <el-option v-for="(item,index) in searchProcedureList" :key="index" :value="item" :label="item"></el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div style="text-align:right">
                        <el-button size="mini" icon="el-icon-search" type="primary" @click="btnSearch()">查询</el-button>
                        <el-button size="mini" icon="el-icon-refresh" @click='clearSearch'>重置</el-button>
                    </div>
                </el-col>
            </el-row>
        </el-card>

        <el-card class="table-card">
            <div class="table_common_operbar" style="margin-bottom:20px">
                <el-row>
                    <el-col style="flex:1">
                        <el-button icon="el-icon-plus" type="primary" v-if="permission.btn_reworkRecord_add" size="small" @click="addWindowShow()">新增</el-button>
                    </el-col>
                </el-row>
            </div>

            <el-table :header-cell-class-name='headStyle' :data="tableData" stripe width=80% class="table_data y_Public_table" :default-sort='defaultSort' @sort-change='sortChangeEvent' >:
                <el-table-column prop="splitCode" label="工单号" min-width="80" show-overflow-tooltip></el-table-column>
                <el-table-column prop="materialCode" label="物料编码" min-width="90" show-overflow-tooltip></el-table-column>
                <el-table-column prop="materialName" label="物料名称" min-width="90" show-overflow-tooltip></el-table-column>
                <el-table-column prop="specification" label="物料规格" min-width="80" show-overflow-tooltip></el-table-column>
                <el-table-column prop="procedureName"  label="工序" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="reworkQuantity" label="返工数量" min-width="60" show-overflow-tooltip></el-table-column>
                <el-table-column prop="reworkUserNames" min-width="100" label="返工执行人" show-overflow-tooltip></el-table-column>
                <el-table-column prop="reworkDeviceNames" min-width="100" label="返工设备" show-overflow-tooltip></el-table-column>
                <el-table-column prop="qualifiedCount" min-width="60" label="合格数量"></el-table-column>
                <el-table-column prop="spoiledCount" min-width="60" label="报废数量" ></el-table-column>
                <el-table-column label="操作" fixed="right" width="150">
                    <template slot-scope="scope">
                        <el-button @click="viewRecord(scope.row)" type="text" size="small" v-if="permission.btn_reworkRecord_detail">查看</el-button>
                        <el-button @click="showEditDialog(scope.row)" type="text" size="small" v-if="permission.btn_reworkRecord_edit">编辑</el-button>
                        <el-button class="btn-del" type="text" size="small" @click="deleteTechnology(scope.row)" v-if="permission.btn_reworkRecord_del">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <div class="total_page"><span> 共{{tableTotalPage}}条 10条/页</span></div>
                <div style="margin-top:3px;text-align:right; margin-bottom:20px;" v-if="tableData.length > 0">
                    <el-pagination background layout="prev, pager, next" :total="tableTotalPage" @current-change="pageChange" :current-page="tableCurrentPage"></el-pagination>
                </div>
            </div>
        </el-card>

        <!-- 新增窗口开始 -->
        <el-dialog title="新建返工任务" style="z-index:99999999999" :visible.sync="centerDialogVisible" width="55%" center :close-on-click-modal="false" :before-close="closeAdd">
            <el-form :model="addForm" :rules="rules" ref="addForm">
                <el-row class="form-row" :gutter="20" style="margin-bottom:20px">
                    <el-col :span="8">
                        <div class="y_technology_flex">
                            <span class="y_flex_Cart is-my-required">工单号：</span>
                            <el-form-item prop="splitId" class="y_Cart_item">
                                <el-select clearable filterable @visible-change="($event)=>{if(!$event){loadProductionBatchCodeAdd('')}}" remote :remote-method="query=>loadProductionBatchCodeAdd(query)" @change="getMaterialProcedureInfo" v-model='addForm.splitId' size='small' placeholder='工单号' >
                                    <el-option v-for="item in productionBatchCodeListAdd" :key="item.splitId" :value="item.splitId" :label="item.productionBatchCode"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="y_technology_flex">
                            <span class="y_flex_Cart is-my-required">物料名称：</span>
                            <el-form-item prop="materialName" class="y_Cart_item">
                                <el-input disabled size="small" v-model="addForm.materialName" placeholder="物料名称"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="y_technology_flex ">
                            <span class="y_flex_Cart is-my-required">物料编码：</span>
                            <el-form-item prop="materialCode" class="y_Cart_item">
                                <el-input disabled size="small" v-model="addForm.materialCode" placeholder="物料编码"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row class="form-row " :gutter="20" style="margin-bottom:20px">
                    <el-col :span="8">
                        <div class="y_technology_flex">
                            <span class="y_flex_Cart">物料规格：</span>
                            <el-form-item class="y_Cart_item">
                                <el-input disabled size="small" v-model="addForm.specification" placeholder="物料规格"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="y_technology_flex">
                            <span class="y_flex_Cart is-my-required">工序：</span>
                            <el-form-item prop="procedureId" class="y_Cart_item">
                                <el-select clearable filterable v-model='addForm.procedureId' @change="procedureChange" style="width:100%" size='small' placeholder='工序' >
                                    <el-option v-for="item in procedureList" :key="item.procedureId" :label="item.procedureName" :value="item.procedureId"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="y_technology_flex">
                            <span class="y_flex_Cart is-my-required">返工数量：</span>
                            <el-form-item prop="reworkQuantity" class="y_Cart_item">
                                <el-input size="small" v-model="addForm.reworkQuantity" maxlength="8" placeholder="返工数量"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    
                </el-row>
                <el-row class="form-row " :gutter="20" style="margin-bottom:20px">
                    <el-col :span="8">
                        <div class="y_technology_flex">
                            <span class="y_flex_Cart is-my-required">返工执行人：</span>
                            <el-form-item prop="reworkUserIds" class="y_Cart_item">
                                <el-select multiple :multiple-limit="5" collapse-tags v-model="addForm.reworkUserIds" @change="userChange" clearable size="small" placeholder="返工执行人" style="width:100%" filterable>
                                    <el-option v-for="user in userOption" :key="user.id" :label="user.name" :value="user.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="y_technology_flex">
                            <span class="y_flex_Cart">返工设备：</span>
                            <el-form-item prop="deviceName" class="y_Cart_item">
                                <el-select multiple :multiple-limit="5" collapse-tags v-model="addForm.reworkDeviceIds" @change="deviceChange" size="small" placeholder="返工设备" style="width:100%" filterable>
                                    <el-option v-for="device in deviceOption" :key="device.id" :label="device.deviceName" :value="device.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="y_technology_flex">
                            <span class="y_flex_Cart is-my-required">合格数量：</span>
                            <el-form-item prop="qualifiedCount" class="y_Cart_item">
                                <el-input size="small" v-model="addForm.qualifiedCount" maxlength="8" placeholder="合格数量"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row class="form-row " :gutter="20" style="margin-bottom:20px">
                    <el-col :span="8">
                        <div class="y_technology_flex">
                            <span class="y_flex_Cart">报废数量：</span>
                            <el-form-item prop="spoiledCount" class="y_Cart_item">
                                <el-input size="small" v-model="addForm.spoiledCount" maxlength="8" placeholder="报废数量"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row class="form-row " :gutter="20" style="margin-bottom:20px">
                    <el-col :span="16">
                        <div class="y_technology_flex">
                            <span class="y_flex_Cart">备注：</span>
                            <el-form-item prop="remark" class="y_Cart_item">
                                <el-input type="textarea" resize="none" :rows="2" placeholder="备注" v-model="addForm.remark" maxlength="50" show-word-limit></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="addReworkSave()">确 定</el-button>
                <el-button @click="closeAdd">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 新增窗口结束 -->

        <!-- 编辑窗口开始 -->
        <el-dialog :title="isEdit?'编辑返工任务':'查看返工任务'" style="z-index:99999999999" :visible.sync="editTechnologyDialogVisible" width="55%" center :close-on-click-modal="false" :before-close="closeEdit">
            <el-form :model="addForm" :rules="rules" ref="editForm">
                <el-row class="form-row" :gutter="20" style="margin-bottom:20px">
                    <el-col :span="8">
                        <div class="y_technology_flex">
                            <span class="y_flex_Cart is-my-required">工单号：</span>
                            <el-form-item prop="splitId" class="y_Cart_item">
                                <el-input disabled size="small" v-model="addForm.splitCode" placeholder="工单号"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="y_technology_flex">
                            <span class="y_flex_Cart is-my-required">物料名称：</span>
                            <el-form-item prop="materialName" class="y_Cart_item">
                                <el-input disabled size="small" v-model="addForm.materialName" placeholder="物料名称"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="y_technology_flex ">
                            <span class="y_flex_Cart is-my-required">物料编码：</span>
                            <el-form-item prop="materialCode" class="y_Cart_item">
                                <el-input disabled size="small" v-model="addForm.materialCode" placeholder="物料编码"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row class="form-row " :gutter="20" style="margin-bottom:20px">
                    <el-col :span="8">
                        <div class="y_technology_flex">
                            <span class="y_flex_Cart">物料规格：</span>
                            <el-form-item class="y_Cart_item">
                                <el-select disabled v-model="addForm.specification" size="small" placeholder="物料规格" style="width:100%" filterable>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="y_technology_flex">
                            <span class="y_flex_Cart is-my-required">工序：</span>
                            <el-form-item prop="procedureId" class="y_Cart_item">
                                <el-select disabled clearable filterable v-model='addForm.procedureId' @change="procedureChange" style="width:100%" size='small' placeholder='工序' >
                                    <el-option v-for="item in procedureList" :key="item.procedureId" :label="item.procedureName" :value="item.procedureId"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="y_technology_flex">
                            <span class="y_flex_Cart is-my-required">返工数量：</span>
                            <el-form-item prop="reworkQuantity" class="y_Cart_item">
                                <el-input size="small" :disabled="!isEdit" v-model="addForm.reworkQuantity" maxlength="8" placeholder="返工数量"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    
                </el-row>
                <el-row class="form-row " :gutter="20" style="margin-bottom:20px">
                    <el-col :span="8">
                        <div class="y_technology_flex">
                            <span class="y_flex_Cart is-my-required">返工执行人：</span>
                            <el-form-item prop="reworkUserIds" class="y_Cart_item">
                                <el-select :disabled="!isEdit" multiple :multiple-limit="5" collapse-tags v-model="addForm.reworkUserIds" @change="userChange" clearable size="small" placeholder="返工执行人" style="width:100%" filterable>
                                    <el-option v-for="user in userOption" :key="user.id" :label="user.name" :value="user.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="y_technology_flex">
                            <span class="y_flex_Cart">返工设备：</span>
                            <el-form-item prop="reworkDeviceIds" class="y_Cart_item">
                                <el-select :disabled="!isEdit" multiple :multiple-limit="5" collapse-tags v-model="addForm.reworkDeviceIds" @change="deviceChange" size="small" placeholder="返工设备" style="width:100%" filterable>
                                    <el-option v-for="device in deviceOption" :key="device.id" :label="device.deviceName" :value="device.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="y_technology_flex">
                            <span class="y_flex_Cart is-my-required">合格数量：</span>
                            <el-form-item prop="qualifiedCount" class="y_Cart_item">
                                <el-input size="small" :disabled="!isEdit" v-model="addForm.qualifiedCount" maxlength="8" placeholder="合格数量"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row class="form-row " :gutter="20" style="margin-bottom:20px">
                    <el-col :span="8">
                        <div class="y_technology_flex">
                            <span class="y_flex_Cart">报废数量：</span>
                            <el-form-item prop="spoiledCount" class="y_Cart_item">
                                <el-input size="small" :disabled="!isEdit" v-model="addForm.spoiledCount" maxlength="8" placeholder="报废数量"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row class="form-row " :gutter="20" style="margin-bottom:20px">
                    <el-col :span="16">
                        <div class="y_technology_flex">
                            <span class="y_flex_Cart">备注：</span>
                            <el-form-item prop="remark" class="y_Cart_item">
                                <el-input type="textarea" :disabled="!isEdit" resize="none" :rows="2" placeholder="备注" v-model="addForm.remark" maxlength="50" show-word-limit></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
            
            <span slot="footer" class="el-dialog__footer" style="text-align: center;" center>
                <el-button v-if="isEdit" type="primary" @click="updateReworkSave()">确 定</el-button>
                <el-button @click="closeEdit" >取消</el-button>
            </span>
        </el-dialog>
     
    </div>
</template>

<script>

export default {
    name: 'ReworkTechnology',
    data() {
        return {
            isEdit:false,
            orderType: 'DESC',//排序类型
            orderColumn: 'gmtCreate',//排序列
            defaultSort: { prop: 'gmtCreate', order: 'descending' },//默认排序设置
            searchCopy: {},
            fristLoad: false,
            materialOldList: [],
            materialList: [],
            loading: false,
            W: false,
            searchForm: {
                splitId: '',
                materialCode: '',
                materialName: '',
                procedureName:'',
                //reworkQuantity:null,
            },
            addForm: {
                id: null,
                splitId: '',
                //materialId: null,
                materialCode: '',
                materialName: '',
                specification:'',
                procedureId:'',
                reworkQuantity:null,
                reworkUserIds:[],
                reworkDeviceIds:[],
                qualifiedCount:null,
                spoiledCount:null,
                remark: ''
            },
            viewForm: {
                splitCode: '',
                //materialId: null,
                materialCode: '',
                materialName: '',
                specification:'',
                procedureName:'',
                reworkQuantity:null,
                reworkUserNames:'',
                reworkDeviceNames:'',
                qualifiedCount:null,
                spoiledCount:null,
                remark: ''
            },
            currentReworkUserNames:[],//当前选中的人员名称集合
            currentReworkDeviceNames:[],//当前选中的设备名称集合
            currentProcedureName:'',//当前工序名称
            productionBatchCodeList:[],
            productionBatchCodeListAdd:[],
            procedureList:[],//新增编辑工序列表
            searchProcedureList:[],//查询框工序列表
            materialCodeList:[],//查询框物料编码列表
            materialNameList:[],//查询框物料名称列表
            product: [],
            userOption:[],
            deviceOption: [],
            centerDialogVisible: false,
            editTechnologyDialogVisible: false,
            procedureData: [],
            parameterData: [],
            tableData: [],
            dialogVisible: false,
            tableCurrentPage: 1,
            tableTotalPage: 100,
            rules: {
                splitId: [
                    { required: true, message: '请选择工单号', trigger: ['blur','change'] }
                ],
                materialCode: [
                    { required: true, message: '请选择物料编码', trigger: ['blur','change'] }
                ],
                materialName: [
                    { required: true, message: '请选择物料名称', trigger: ['blur','change'] }
                ],
                reworkUserIds:[
                    { required: true, message: '请选择返工执行人', trigger: ['blur','change'] }
                ],
                procedureId: [
                    { required: true, message: '请选择工序名称', trigger: ['blur','change'] }
                ],
                reworkQuantity:[
                    { required: true, message: '请输入返工数量', trigger: 'blur' },
                    {validator(rule, value, callback) {
                        if(value){
                            value = Number(value)
                            if(isNaN(value)){
                                callback(new Error('请输入数字'))
                            }else{
                                if ( Number.isInteger(value)&& value > 0) {
                                    callback()
                                } else {
                                    callback(new Error('请输入大于0的正整数'))
                                }
                            }
                        }else{
                            callback()
                        }
					},trigger: 'blur'}
                ],
                workerName:[
                    { required: true, message: '请选择返工执行人', trigger: ['blur'] }
                ],
                qualifiedCount:[
                    { required: true, message: '请输入合格数量', trigger: 'blur' },
                    {validator(rule, value, callback) {
                        if(value){
                            value = Number(value)
                            if(isNaN(value)){
                                callback(new Error('请输入数字'))
                            }else{
                                if ( Number.isInteger(value)) {
                                    console.log()
                                    callback()
                                } else {
                                    callback(new Error('请输入0或正整数'))
                                }
                            }
                        }else{
                            callback()
                        }
					},trigger: 'blur'}
                ],
                spoiledCount:[
                    { required: false, message: '请输入报废数量', trigger: 'blur' },
                    {validator(rule, value, callback) {
                        if(value){
                            value = Number(value)
                            if(isNaN(value)){
                                callback(new Error('请输入数字'))
                            }else{
                                if ( Number.isInteger(value)) {
                                    callback()
                                } else {
                                    callback(new Error('请输入0或正整数'))
                                }
                            }
                        }else{
                            callback()
                        }
					},trigger: 'blur'}
                ]
            },
            permission: JSON.parse(localStorage.getItem("permission"))
        }
    },
    
    mounted: function () {
        this.initTable();
        this.loadProductionBatchCode();
        this.loadProcedureList();
        this.loadMaterialCodeList();
        this.loadMaterialNameList();
        this.getUserOption();
        this.getDeviceOption();
        let w = document.documentElement.clientWidth || document.body.clientWidth;
        w >= 1900 ? this.W = true : this.W = false
        window.onresize = () => {
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            w >= 1900 ? this.W = true : this.W = false
        }
    },
    filters: {
        
    },
    methods: {
        //父组件的方法
        //排序改变事件
        sortChangeEvent(param) {
            console.log(param);
            let orderType = param.order;
            let orderColumn = param.prop;
            this.orderColumn = orderColumn;
            if (orderType == 'descending') {
                this.orderType = 'DESC';
            } else if (orderType == 'ascending') {
                this.orderType = 'ASC';
            } else {
                this.orderType = orderType;
                this.orderColumn = null
            }

            if (this.comebackFlag) {
                this.comebackFlag = false;
                console.log('排序', this.oldPageNum)
                if (this.oldPageNum) {
                    this.tableCurrentPage = this.oldPageNum
                }
                this.search(this.tableCurrentPage);

            } else {
                this.search(1);
            }
            this.tableCurrentPage = 1
        },

        headStyle({ row, column, rowIndex, columnIndex }) {
            if (columnIndex == 0) {
                return 'cell1-class'
            }
        },

        clearDate() {
            this.addForm.materialName = null
            this.addForm.materialCode = null
            this.addForm.itemType = null
        },

        async loadMaterialList(itemType, materialName, materialCode) {
            let res = await this.$RequestUtil.getAsync({
                url: '/api/select/listMaterial',
                params: { itemType, materialCode, materialName, isTechnology: true }
            })
            if (itemType != 0 && itemType != 1 && !materialCode & !materialName) {
                this.materialOldList = res.data
            }
            this.materialList = res.data
            return res.data
        },
        
     
        async changeMaterialList(ev, type) {
            if (!ev) {
                let info = null
                if (this.addForm.materialId) {
                    info = this.materialList.find(item => item.id == this.addForm.materialId)
                    if (this.addForm.specification == null || this.addForm.specification == undefined) {
                        this.$set(this.addForm, 'specification', info.specification)
                    }

                }
                let data = await this.loadMaterialList(this.addForm.itemType, null, null)
                if (info) {
                    let has = data.find(item => item.id == info.id)
                    if (has) {
                    } else {
                        this.materialList.unshift(info)
                    }
                }
            }
        },

        async loadProcedureList(procedureName){
            this.loading = true
            let {data} = await this.$RequestUtil.getAsync({url: '/api/select/listProcedure',params: { procedureName },})
            this.searchProcedureList = data
            this.loading = false
        },
        async loadMaterialCodeList(materialCode){
            this.loading = true
            let {data,code,msg,message} = await this.$RequestUtil.getAsync({url: "/api/select/listMaterial",params: {materialCode}});
            this.materialCodeList = data
            this.loading = false
        },
        async loadMaterialNameList(materialName){
            this.loading = true
            let {data,code,msg,message} = await this.$RequestUtil.getAsync({url: "/api/select/listMaterial",params: {materialName}});
            this.materialNameList = data
            this.loading = false
        },

        async loadProductionBatchCode(productionBatchCode){
            this.loading = true
            let {data,code,msg,message} = await this.$RequestUtil.getAsync({url: '/api/select/listProductionBatchCode',type:'async',params: {productionBatchCode}})
            this.productionBatchCodeList = data
            this.loading = false
        },
        async loadProductionBatchCodeAdd(productionBatchCode){
            this.loading = true
            let {data,code,msg,message} = await this.$RequestUtil.getAsync({url: '/api/select/listProductionBatchCode',type:'async',params: {productionBatchCode}})
            this.productionBatchCodeListAdd = data
            this.loading = false
        },
      
        async remoteMethod(query) {
            this.loading = true;
            let data = await this.loadMaterialList(this.addForm.itemType, query, null)
            this.loading = false
        },

        async remoteMethod1(query) {
            this.loading = true;
            let data = await this.loadMaterialList(this.addForm.itemType, null, query)
            this.loading = false
        },
        async getUserOption(name){
            this.loading = true
            let {data} = await this.$RequestUtil.getAsync({url: '/api/select/listWorker',type:'sync',params:{name},})
            this.userOption = data
            this.loading = false
        },
        async getDeviceOption(deviceName) {
            this.loading = true
            let {data} = await this.$RequestUtil.getAsync({url: '/api/pull/list/info-for-order',type: 'sync',params: {deviceName},})
            this.deviceOption = data;
            this.loading = false
        },

        getMaterialProcedureInfo(splitId){
            if(splitId==""){
                this.addForm.materialCode = "";
                this.addForm.materialName = "";
                this.addForm.specification = "";
                this.addForm.procedureId = "";
                this.procedureList = [];
            }
            return this.$RequestUtil.get({
                url:'/api/select/getMaterialProcedureInfo',
                params:{
                    splitId:this.addForm.splitId
                },
                success: (res) => {
                    if(res.code == 0){
                        this.addForm.materialCode = res.data.materialCode;
                        this.addForm.materialName = res.data.materialName;
                        this.addForm.specification = res.data.specification;
                        this.addForm.procedureId = '';
                        this.procedureList = res.data.procedureList;
                    }
                }
            })
        },

        reload() {
            this.initTable();
            this.$store.commit('delete_reloadPages', '/Technology')
            this.$forceUpdate()
        },

        procedureChange(){
            this.currentProcedureName = (this.procedureList.find(item=>item.procedureId==this.addForm.procedureId)||'').procedureName;
        },

        userChange(){
            this.currentReworkUserNames = [];
            this.addForm.reworkUserIds.forEach((val)=>{
                this.currentReworkUserNames.push((this.userOption.find(item=>item.id==val)).name);
            })
        },

        deviceChange(){
            this.currentReworkDeviceNames = [];
            this.addForm.reworkDeviceIds.forEach((val)=>{
                this.currentReworkDeviceNames.push((this.deviceOption.find(item=>item.id==val)).deviceName);
            })
        },
        btnSearch: function () {
            this.searchCopy = commonUtils.cloneObj(this.searchForm)
            this.tableCurrentPage = 1;
            this.search();
        },

        clearSearch() {
            let form = this.searchForm;
            form.splitId = '';
            form.materialCode = '';
            form.materialName = '';
            form.procedureName = '';
            form.reworkQuantity = null
        },

        search: function () {
            this.$RequestUtil.loading()
            this.$RequestUtil.get({
                url: '/api/reworkRecord/list',
                type:'sync',
                params: {
                    pageNum: this.tableCurrentPage,
                    pageSize: 10,
                    orderType: this.orderType,
                    orderColumn: this.orderColumn,
                    splitId: this.searchForm.splitId,
                    materialCode: this.searchForm.materialCode,
                    materialName: this.searchForm.materialName,
                    procedureName: this.searchForm.procedureName,
                    //reworkQuantity: this.searchForm.reworkQuantity
                },
                success: (res) => {
                    this.$RequestUtil.loading().close()
                    if (res.msg == "success") {
                        res.data.forEach(item=>{
                            item.splitCode = item.childProductionBatchCode||item.splitCode
                        })
                        this.tableData = res.data;
                        this.tableTotalPage = res.totalPages;
                        if (res.totalPages == 0 && this.fristLoad) {
                            this.$message.warning('查询不到符合条件的数据');
                        }
                        this.fristLoad = true
                    } else {
                        this.$message.error(res.message || res.msg)
                    }

                }
            });
        },

        pageChange: function (targetPage) {
            this.$set(this, 'searchForm', commonUtils.cloneObj(this.searchCopy));
            this.tableCurrentPage = targetPage;
            this.search();
        },

        initTable: function () {
            this.search();
        },

        addWindowShow: function () {
            this.loadProductionBatchCodeAdd();
            this.procedureData = [];
            this.parameterData = [];
            this.addForm = {
                id: null,
                splitId: '',
                materialCode: '',
                materialName: '',
                specification:'',
                procedureId:'',
                reworkQuantity:null,
                reworkUserIds:[],
                reworkDeviceIds:[],
                qualifiedCount:null,
                spoiledCount:null,
                remark: ''
            }
            this.centerDialogVisible = true;
        },
     
        addReworkSave: function () {
            this.$refs['addForm'].validate((valid) => {
                if (valid) {
                    if((Number(this.addForm.qualifiedCount)+Number(this.addForm.spoiledCount)) != Number(this.addForm.reworkQuantity)){
                        this.$message({
                            type: 'warning',
                            message: '合格数量加报废数量必须等于返工数量！'
                        })
                        return
                    }
                    if(this.addForm.procedureId!='' && this.currentProcedureName==''){
                        this.procedureChange();
                    }
                    if(this.addForm.reworkUserIds.length>0 && this.currentReworkUserNames.length!=this.addForm.reworkUserIds.length){
                        this.userChange();
                    }
                    if(this.addForm.reworkDeviceIds.length>0 && this.currentReworkDeviceNames.length!=this.addForm.reworkDeviceIds.length){
                        this.deviceChange();
                    }
                    this.$RequestUtil.post({
                        url: '/api/reworkRecord/add',
                        type: 'sync',
                        params: {
                            splitId: this.addForm.splitId,
                            materialCode: this.addForm.materialCode,
                            materialName: this.addForm.materialName,
                            specification: this.addForm.specification,
                            procedureId: this.addForm.procedureId,
                            procedureName: this.currentProcedureName,
                            reworkQuantity: this.addForm.reworkQuantity,
                            reworkUserIds: this.addForm.reworkUserIds.length>0?this.addForm.reworkUserIds.join(','):'',
                            reworkUserNames: this.currentReworkUserNames.length>0?this.currentReworkUserNames.join(','):'',
                            reworkDeviceIds: this.addForm.reworkDeviceIds.length>0?this.addForm.reworkDeviceIds.join(','):'',
                            reworkDeviceNames: this.currentReworkDeviceNames.length>0?this.currentReworkDeviceNames.join(','):'',
                            qualifiedCount: this.addForm.qualifiedCount,
                            spoiledCount: this.addForm.spoiledCount,
                            remark: this.addForm.remark,
                        },
                        success: (res) => {
                            if (res.code == 0) {
                                this.$message({
                                    type: 'success',
                                    message: '添加成功'
                                })
                                this.initTable();
                                this.closeAdd();
                            } else {
                                this.$message({
                                    type: 'error',
                                    message: res.msg || res.message
                                });
                            }
                        }
                    });
                    
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        closeAdd(){
            this.currentReworkUserNames = [];
            this.currentReworkDeviceNames = [];
            this.currentProcedureName = '';
            this.$refs['addForm'].resetFields();
            this.centerDialogVisible = false
        },
        
        getDetail(id,type){
            this.$RequestUtil.get({
                url:'/api/reworkRecord/detail',
                params:{
                    id:id
                },
                success: (res) => {
                    if(res.code == 0){
                        //编辑
                        if(type=="edit"){
                            this.addForm.id = res.data.id;
                            this.addForm.splitId = res.data.splitId;
                            this.getMaterialProcedureInfo(res.data.splitId).then(()=>{
                                this.addForm.procedureId = res.data.procedureId;
                                this.currentProcedureName = res.data.procedureName;
                            })
                            this.addForm.materialName = res.data.materialName;
                            this.addForm.specification = res.data.specification;
                            this.addForm.reworkQuantity = res.data.reworkQuantity;
                            this.addForm.reworkUserIds = res.data.reworkUserIds!=''?res.data.reworkUserIds.split(',').map((val)=>{return Number(val)}):[];
                            this.currentReworkUserNames = res.data.reworkUserNames!=''?res.data.reworkUserNames.split(','):[];
                            this.addForm.reworkDeviceIds = res.data.reworkDeviceIds!=''?res.data.reworkDeviceIds.split(',').map((val)=>{return Number(val)}):[];
                            this.currentReworkDeviceNames = res.data.reworkDeviceNames!=''?res.data.reworkDeviceNames.split(','):[];
                            this.addForm.qualifiedCount = res.data.qualifiedCount;
                            this.addForm.spoiledCount = res.data.spoiledCount;
                            this.addForm.remark = res.data.remark;
                            this.addForm.splitCode = res.data.splitCode;
                        }else{
                            //查看
                            this.addForm.splitId = res.data.splitId;
                            this.getMaterialProcedureInfo(res.data.splitId).then(()=>{
                                this.addForm.procedureId = res.data.procedureId;
                                this.currentProcedureName = res.data.procedureName;
                            })
                            this.addForm.reworkUserIds = res.data.reworkUserIds!=''?res.data.reworkUserIds.split(',').map((val)=>{return Number(val)}):[];
                            this.currentReworkUserNames = res.data.reworkUserNames!=''?res.data.reworkUserNames.split(','):[];
                            this.addForm.reworkDeviceIds = res.data.reworkDeviceIds!=''?res.data.reworkDeviceIds.split(',').map((val)=>{return Number(val)}):[];
                            this.currentReworkDeviceNames = res.data.reworkDeviceNames!=''?res.data.reworkDeviceNames.split(','):[];
                            this.addForm.materialCode = res.data.materialCode;
                            this.addForm.splitCode = res.data.splitCode;
                            this.addForm.materialName = res.data.materialName;
                            this.addForm.specification = res.data.specification;
                            this.addForm.procedureName = res.data.procedureName;
                            this.addForm.reworkQuantity = res.data.reworkQuantity;
                            this.addForm.reworkUserNames = res.data.reworkUserNames;
                            this.addForm.reworkDeviceNames = res.data.reworkDeviceNames;
                            this.addForm.qualifiedCount = res.data.qualifiedCount;
                            this.addForm.spoiledCount = res.data.spoiledCount;
                            this.addForm.remark = res.data.remark;
                        }
                    }
                }
            })
        },

        updateReworkSave: function () {
            this.$refs['editForm'].validate((valid) => {
                if (valid) {
                    if((Number(this.addForm.qualifiedCount)+Number(this.addForm.spoiledCount)) != Number(this.addForm.reworkQuantity)){
                        this.$message({
                            type: 'warning',
                            message: '合格数量加报废数量必须等于返工数量！'
                        })
                        return
                    }
                    if(this.addForm.procedureId!='' && this.currentProcedureName==''){
                        this.procedureChange();
                    }
                    if(this.addForm.reworkUserIds.length>0 && this.currentReworkUserNames.length!=this.addForm.reworkUserIds.length){
                        this.userChange();
                    }
                    if(this.addForm.reworkDeviceIds.length>0 && this.currentReworkDeviceNames.length!=this.addForm.reworkDeviceIds.length){
                        this.deviceChange();
                    }
                    this.$RequestUtil.loading()
                    this.$RequestUtil.post({
                        url: '/api/reworkRecord/edit',
                        // type:'sync',
                        params: {
                            id: this.addForm.id,
                            splitId: this.addForm.splitId,
                            materialCode: this.addForm.materialCode,
                            materialName: this.addForm.materialName,
                            specification: this.addForm.specification,
                            procedureId: this.addForm.procedureId,
                            procedureName: this.currentProcedureName,
                            reworkQuantity: this.addForm.reworkQuantity,
                            reworkUserIds: this.addForm.reworkUserIds.length>0?this.addForm.reworkUserIds.join(','):'',
                            reworkUserNames: this.currentReworkUserNames.length>0?this.currentReworkUserNames.join(','):'',
                            reworkDeviceIds: this.addForm.reworkDeviceIds.length>0?this.addForm.reworkDeviceIds.join(','):'',
                            reworkDeviceNames: this.currentReworkDeviceNames.length>0?this.currentReworkDeviceNames.join(','):'',
                            qualifiedCount: this.addForm.qualifiedCount,
                            spoiledCount: this.addForm.spoiledCount,
                            remark: this.addForm.remark,
                        },
                        success: (res) => {
                            if (res.code == 0) {
                                this.$message({
                                    type: 'success',
                                    message: '修改成功'
                                })
                                this.initTable();
                                this.closeEdit()
                            } else {
                                this.$RequestUtil.loading().close()
                                this.$message({
                                    type: 'error',
                                    message: res.message
                                });
                            }
                        }
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        closeEdit(){
            this.currentReworkUserNames = [];
            this.currentReworkDeviceNames = [];
            this.currentProcedureName = '';
            
            this.$refs['editForm'].resetFields()
           // this.$refs['editForm'].clearValidate()
            this.editTechnologyDialogVisible=false;
            if(this.$refs['addForm']){this.$refs['addForm'].resetFields()};
        },
        showEditDialog: async function (rowData) {
            this.getDetail(rowData.id,'edit');
            this.isEdit = true
            this.editTechnologyDialogVisible = true;
        },

        viewRecord: async function (rowData) {
            this.getDetail(rowData.id,'view');
            this.isEdit = false
            this.editTechnologyDialogVisible = true;
        },

     
        deleteTechnology: function (rowData) {
            this.$confirm('此操作将删除该记录, 是否继续?', '提示', {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$RequestUtil.post({
                    url: '/api/reworkRecord/del',
                    type: 'sync',
                    params: {
                        id: rowData.id
                    },
                    success: (res) => {
                        if (res.code == 0) {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.initTable();
                        } else if (res.code == -1) {
                            this.$message({
                                type: 'error',
                                message: '该记录不可删除!'
                            });
                        }
                    },

                });
            });
        },
    },
    computed: {
        span() {
            return this.W ? 6 : 7
        }
    },
    watch: {

    },
}
</script>

<style scoped>

.el-row {
    margin-bottom: 10px;

    & :last-child {
        margin-bottom: 0;
    }
}
.form-row {
    margin-bottom: 0px;
}

.bg-purple {
    background: #d3dce6;
}



.el-upload--picture-card {
    width: 40px;
    height: 40px;
}

.file-icon-container {
    width: 36px;
    height: 45px;
    margin-top: 0px;

    background-size: cover;
    position: relative;
    cursor: pointer;
}

.file-delete {
    position: absolute;
    top: -6px;
    left: 28px;
    width: 15px;
    height: 15px;
    background-image: URL("../../static/img/delete.png");
    background-size: cover;
    cursor: pointer;
}

.margin_right_140 {
    margin-right: 140px;
}

.table_container {
    border: 1px solid #e2e2e2;
    border-radius: 1%;
    overflow: hidden;
}

.table_common_operbar {
    margin-top: 4px;
}

.table_data {
    /* margin-left: 26px; */
    margin-right: 26px;
}

.page {
    display: flex;
    justify-content: flex-end;
}

.total_page {
    margin-top: 8px;
    margin-right: 26px;
    color: #606266;
    font-size: 14px;
}

.set_header_color {
    color: #303133;
}

.el-dialog__footer {
    display: flex;
    justify-content: center;
}

.el-dialog__body {
    padding-top: 0px;
}

@media screen and (max-width: 1440px) {
    .page {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 30px;
    }
}

.key {
    font-size: 16px;
    color: #c0c4cc;
    font-family: NotoSansHans-Regula;
    padding-right: 10px;
}

.value {
    
}

.color-blue {
    color: blue;
}

.el-icon-circle-close-outline:hover {
    color: red;
}

.delete {
    width: 18px;
    height: 19px;
    background-image: url("../../../static/img/del.png");
    cursor: pointer;
    background-repeat: no-repeat;
}

.delete:hover {
    background-image: url("../../../static/img/del-hover.png");
    background-repeat: no-repeat;
}

.import_upload {
    display: inline;
}

.table_searchbar .title11 {
    color: #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
}

.is-my-required:before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
    /* position: absolute;
    left: -10px; */
}

.y_inline {
    display: inline-block;
}
.y_flex {
    display: flex;
}

.y_technology_flex {
    display: flex;
}

.y_flex_title {
    width: 100px !important;
    height: 32px;
    line-height: 32px;
    text-align: right;
    /*align-self: center;*/
}

.y_flex_item {
    height: 32px;
    align-self: center;
    /*margin-left: 5px;*/
    flex: 1;
}

.y_flex_Cart {
    width: 100px !important;
    height: 32px;
    line-height: 32px;
    text-align: right;
}

.y_Cart_item {
    height: 32px;
    align-self: center;
    /*margin-left: 5px;*/
    flex: 1;
}

.y_flex_item .el-select {
    width: 100% !important;
}

.y_Cart_item .el-select {
    width: 100% !important;
}

.y_margin_left30 {
    margin-left: 30px;
}

.y_margin {
    margin-left: 28px;
}

.y_table {
    display: table;
}

/* .y_table_span {
    width: 80px !important;
    height: 31px;
    line-height: 31px;
    text-align: right;
    display: inline-block;
} */

.y_table_cellLogy {
    display: table-cell;
    width: inherit;
}

.y_table_cellLogy .el-date-editor.el-input,
.el-date-editor.el-input__inner {
    line-height: inherit;
}

.y_table .el-autocomplete {
    width: 100% !important;
}

.y_table_cellLogy .el-range-editor--small .el-range__icon {
    line-height: 0 !important;
    position: relative;
    top: 13px;
}

.el-col {
    padding-left: 15px;
}
</style>
<style>
#reworkRecord .el-textarea__inner{
    font-family: inherit;
}
.cell1-class .cell {
    margin-left: 5px;
}

.table_searchbar .el-button--mini,
.el-button--mini.is-round {
    padding: 7px 10px;
}

.select_width {
    width: 170px;
}

@media screen and (max-width: 1366px) {
    .test .el-input {
        width: auto !important;
        max-width: 120px;
    }

    .form-row .el-input {
        width: 100% !important;
        min-width: 80px;
    }

    #technology .el-date-editor.el-input,
    #technology .el-date-editor.el-input__inner {
        width: 176px !important;
    }

    .y_flex_item .el-select {
        width: 100% !important;
        min-width: 80px;
    }
}
</style>




// WEBPACK FOOTER //
// src/views/Rework/ReworkRecord.vue